"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("@pbl/pbl-react-core/lib/config/config");
var types_1 = require("@pbl/pbl-react-core/lib/models/reward/types");
var hideable_1 = require("@pbl/pbl-react-web-components/lib/hideable");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var page_container_1 = require("@pbl/pbl-react-web-components/lib/page-container");
var RedeemConfirmationModal_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/reward-detail/RedeemConfirmationModal"));
var RedeemModal_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/reward-detail/RedeemModal"));
var RedemptionDetail_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/reward-detail/RedemptionDetail"));
var CouponDetailV2_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/reward-detail/v2/CouponDetailV2"));
var RewardCouponModalV2_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/reward-detail/v2/RewardCouponModalV2"));
var RewardDetailV2_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/reward-detail/v2/RewardDetailV2"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importStar(require("../../config/constants"));
var rewardUtil_1 = require("../../modules/RewardWidget/components/rewardUtil");
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/arcade/actions");
var actions_3 = require("../../redux/reducers/ledger/actions");
var actions_4 = require("../../redux/reducers/loyalty/actions");
var action_1 = require("../../redux/reducers/rewards/action");
var rewardDatesUtil_1 = require("../../shared/hooks/providers/rewards/rewardDatesUtil");
var useRewardData_1 = require("../../shared/hooks/providers/rewards/useRewardData");
var useDrawData_1 = require("../../shared/hooks/providers/useDrawData");
var useIsLoggedIn_1 = require("../../shared/hooks/providers/useIsLoggedIn");
var usePointsBalanceData_1 = __importDefault(require("../../shared/hooks/providers/usePointsBalanceData"));
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var ArcadeGame_1 = __importDefault(require("../Arcade/ArcadeGame"));
var RewardDetailScreen = function (_a) {
    var _b, _c;
    var identifier = _a.identifier;
    var dispatch = (0, react_redux_1.useDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var rewardId = identifier;
    var navigateToRewards = (0, react_1.useCallback)(function (message) {
        var appNavigate = {
            action: 'REWARDS',
            data: message
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }, []);
    var redirectContactUs = function () {
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var showInvalidRewardError = (0, react_1.useCallback)(function () {
        navigateToRewards({
            message: t('rewards.rewardUnavailable'),
            type: 'warning',
            messageTimeout: 3000
        });
    }, [navigateToRewards, t]);
    var _d = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _d.isAuthenticated, authenticating = _d.authenticating, isRestricted = _d.isRestricted;
    var _e = (0, react_1.useState)(), selectedDraw = _e[0], setSelectedDraw = _e[1];
    var _f = (0, react_1.useState)('prize'), gameType = _f[0], setGameType = _f[1];
    var _g = (0, react_1.useState)(false), launchGame = _g[0], setLaunchGame = _g[1];
    var _h = (0, useRewardData_1.useRewardData)(rewardId.toString(), showInvalidRewardError), selectedReward = _h.reward, activeDraw = _h.activeDraw, coupon = _h.coupon, promotion = _h.promotion;
    var _j = (0, useRewardData_1.useRewardData)(rewardId.toString(), showInvalidRewardError), redemption = _j.redemption, setRedemption = _j.setRedemption;
    var _k = (0, usePointsBalanceData_1.default)(isLoggedIn, constants_1.default.SECOND_CHANCE_ONLY), loyaltyBalance = _k.loyaltyBalance, loyaltyBalanceLoading = _k.loading;
    var _l = (0, react_redux_1.useSelector)(function (state) { return state.loyalty; }), barcodeData = _l.barcodeData, rewardDigitalDownload = _l.rewardDigitalDownload;
    var _m = (0, useDrawData_1.useDrawData)(selectedDraw === null || selectedDraw === void 0 ? void 0 : selectedDraw.id, selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.externalId), draws = _m.draws, drawHistoryRetrieved = _m.drawHistoryRetrieved, drawPrizes = _m.drawPrizes, drawPrizesWithWinners = _m.drawPrizesWithWinners, drawEntries = _m.drawEntries, latestDrawHistory = _m.latestDrawHistory;
    var _o = (0, react_1.useState)(false), showModal = _o[0], setShowModal = _o[1];
    var _p = (0, react_1.useState)(false), showCouponModal = _p[0], setShowCouponModal = _p[1];
    var _q = (0, react_1.useState)(false), showModalConfirmation = _q[0], setShowModalConfirmation = _q[1];
    var _r = (0, react_1.useState)(false), showDigitalDownloadModal = _r[0], setShowDigitalDownloadModal = _r[1];
    var _s = (0, react_1.useState)(0), redeemQuantity = _s[0], setRedeemQuantity = _s[1];
    var arcades = (0, react_redux_1.useSelector)(function (state) { return state.arcades; });
    var loggedIn = (0, useIsLoggedIn_1.useIsLoggedIn)();
    var isCouponType = (selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.type) === types_1.RewardType.COUPON;
    var isRedemptionType = (selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.type) === types_1.RewardType.EXTERNAL;
    var isGamePlayType = (selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.type) === types_1.RewardType.GAMEPLAY;
    (0, useScrollToTop_1.useScrollToTop)();
    (0, react_1.useEffect)(function () {
        dispatch((0, actions_3.fetchUserPoints)());
    }, [dispatch]);
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var onPlay = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!loggedIn && !authenticating) {
                redirectToLogin();
            }
            setGameType('prize');
            dispatch((0, actions_2.debitArcadeGameV2)((selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.amount) || 0, (selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.key) || ''));
            setLaunchGame(true);
            return [2];
        });
    }); };
    (0, useScrollToTop_1.useScrollToTop)();
    var showRedeemError = function (e) {
        var hasErrorKey = e.hasOwnProperty('payload') ? e.payload.hasOwnProperty('errorKey') : false;
        var defaultErrorMessage = e.hasOwnProperty('message') ? e.message : e;
        var errorMessage = hasErrorKey
            ? t(e.payload.errorKey, defaultErrorMessage)
            : defaultErrorMessage;
        dispatch((0, actions_1.showMessageBar)({
            message: errorMessage,
            type: 'error',
            messageTimeout: 10000
        }));
    };
    var showRedeemSuccess = function () {
        if (isCouponType) {
            setShowModal(false);
            setShowCouponModal(true);
            return;
        }
        if (rewardDigitalDownload) {
            setShowDigitalDownloadModal(true);
            return;
        }
        setShowModalConfirmation(true);
    };
    var navigateWithRedeemSuccess = function () {
        onModalClose();
        if (!constants_1.default.HIDE_MESSAGE_BAR) {
            dispatch((0, actions_1.showMessageBar)({
                message: t('rewards.redeemSuccess'),
                type: 'success',
                messageTimeout: 10000
            }));
        }
        navigateToRewards();
    };
    var closeModalConfirmationDialog = function () {
        setShowModalConfirmation(false);
        framework_1.GoFwInternalInstance.onEarnActivity();
        navigateToRewards();
    };
    var onRedeem = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!loggedIn) {
                framework_1.GoFwInternalInstance.onHostLogin();
                return [2];
            }
            dispatch((0, actions_1.clearMessages)());
            setShowModal(true);
            setRedeemQuantity(1);
            return [2];
        });
    }); };
    var requestRedeem = function () { return __awaiter(void 0, void 0, void 0, function () {
        var redeemData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedReward) {
                        return [2];
                    }
                    if (!isCouponType) return [3, 2];
                    return [4, (0, action_1.redeemCupon)(selectedReward.key, showRedeemError)];
                case 1:
                    redeemData = _a.sent();
                    if (!redeemData)
                        return [2];
                    dispatch((0, actions_4.getBarcodeData)(selectedReward.key, redeemData.code, redeemData.humanReadable));
                    showRedeemSuccess();
                    return [2];
                case 2:
                    setShowModal(false);
                    _a.label = 3;
                case 3:
                    dispatch((0, action_1.redeemReward)(selectedReward.id.toString(), redeemQuantity, showRedeemSuccess, showRedeemError));
                    return [2];
            }
        });
    }); };
    var onModalClose = function () {
        setShowModal(false);
        setShowCouponModal(false);
    };
    var selectDraw = function (draw) {
        setSelectedDraw(draw);
    };
    var gameEnded = function () { return __awaiter(void 0, void 0, void 0, function () {
        var digitalRevealToken, redemptionFrequency;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch((0, actions_2.resetGame)());
                    digitalRevealToken = (_a = arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig) === null || _a === void 0 ? void 0 : _a.prizes[0].digitalRevealToken;
                    if (digitalRevealToken) {
                        dispatch((0, actions_2.endDigitalArcadeGameData)(digitalRevealToken));
                    }
                    if (!(selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.key)) return [3, 2];
                    return [4, (0, action_1.fetchRedemption)(selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.key)];
                case 1:
                    redemptionFrequency = _b.sent();
                    setRedemption(__assign({}, redemptionFrequency));
                    _b.label = 2;
                case 2:
                    dispatch((0, actions_3.fetchUserPoints)());
                    setLaunchGame(false);
                    framework_1.GoFwInternalInstance.onEarnActivity();
                    return [2];
            }
        });
    }); };
    var closeGame = function () {
        gameEnded();
    };
    if (!selectedReward) {
        return null;
    }
    var rewardEndDate = (0, rewardDatesUtil_1.formatRewardDate)('drawStartEndDateFormat', t('reward.tbd'), selectedReward.end);
    var drawDate = (0, rewardDatesUtil_1.formatRewardDate)('drawDrawDateFormat', t('reward.tbd'), activeDraw === null || activeDraw === void 0 ? void 0 : activeDraw.draw);
    var isRewardEnded = (0, rewardUtil_1.isEnded)(selectedReward.end);
    var isRewardEndingSoon = selectedReward.type === types_1.RewardType.DRAW &&
        !!promotion &&
        (0, rewardUtil_1.isEndingSoon)(promotion.endingSoon, promotion.entryEnd);
    var maxRedeemAvailable = selectedReward
        ? Math.floor(Math.min(loyaltyBalance / selectedReward.amount, ((_b = selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.frequencyCap) === null || _b === void 0 ? void 0 : _b.remaining) || config_1.MAX_SAFE_INTEGER, (isCouponType && (coupon === null || coupon === void 0 ? void 0 : coupon.remaining)) || config_1.MAX_SAFE_INTEGER, (isRedemptionType && (redemption === null || redemption === void 0 ? void 0 : redemption.remaining)) || config_1.MAX_SAFE_INTEGER))
        : 0;
    var getSpinResultsFromExtraData = function (extraData) {
        try {
            if (!!extraData) {
                var obj = JSON.parse(extraData);
                if (!!obj.spinResults) {
                    return JSON.stringify(obj.spinResults);
                }
            }
        }
        catch (e) {
            return undefined;
        }
    };
    var spinResults;
    var gamePoints = (arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig) &&
        (arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig.prizes) &&
        (arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig.prizes.length) > 0
        ? arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig.prizes[0].amount
        : 0;
    if ((arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig) &&
        (arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig.prizes) &&
        (arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig.prizes.length) > 0 &&
        !!(arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig.prizes[0].extraData)) {
        spinResults = getSpinResultsFromExtraData(arcades === null || arcades === void 0 ? void 0 : arcades.sweepstakesGameConfig.prizes[0].extraData);
    }
    var renderRewardDetail = function () {
        if (isCouponType) {
            return (selectedReward && (react_1.default.createElement(CouponDetailV2_1.default, { userPoints: loyaltyBalance, selectedReward: selectedReward, loyaltyBalance: loyaltyBalance, onRedeem: onRedeem, isLoggedIn: loggedIn, maxRedeemAvailable: maxRedeemAvailable, onNavigate: navigateToRewards, showSoldOutTag: constants_1.default.SHOW_COUPON_SOLD_OUT_BANNER, remainingCoupons: coupon === null || coupon === void 0 ? void 0 : coupon.remaining, availabilityEndDate: rewardEndDate, drawDate: drawDate, isEnded: isRewardEnded, isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs, hideBackButton: constants_1.default.HIDE_REWARD_EARN_LIST_ICON, showSignInWarning: !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING'), redirectToLogin: redirectToLogin })));
        }
        if (isRedemptionType) {
            return (selectedReward && (react_1.default.createElement(RedemptionDetail_1.default, { userPoints: loyaltyBalance, selectedReward: selectedReward, loyaltyBalance: loyaltyBalance, onRedeem: onRedeem, isLoggedIn: loggedIn, maxRedeemAvailable: maxRedeemAvailable, onNavigate: navigateToRewards, showSoldOutTag: constants_1.default.SHOW_COUPON_SOLD_OUT_BANNER, remainingRedemptions: (redemption === null || redemption === void 0 ? void 0 : redemption.remaining) || 0, availabilityEndDate: rewardEndDate, drawDate: drawDate, isEnded: isRewardEnded, isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs })));
        }
        if (isGamePlayType) {
            return (selectedReward && (react_1.default.createElement(RedemptionDetail_1.default, { userPoints: loyaltyBalance, selectedReward: selectedReward, loyaltyBalance: loyaltyBalance, onRedeem: onPlay, isLoggedIn: loggedIn, maxRedeemAvailable: maxRedeemAvailable, onNavigate: navigateToRewards, showSoldOutTag: constants_1.default.SHOW_COUPON_SOLD_OUT_BANNER, remainingRedemptions: (redemption === null || redemption === void 0 ? void 0 : redemption.remaining) || 0, availabilityEndDate: rewardEndDate, drawDate: drawDate, isEnded: isRewardEnded, buttonText: t('arcade.button.play'), isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs })));
        }
        return (selectedReward && (react_1.default.createElement(RewardDetailV2_1.default, { selectedReward: selectedReward, selectDraw: selectDraw, onRedeem: onRedeem, isLoggedIn: loggedIn, maxRedeemAvailable: maxRedeemAvailable, onNavigate: navigateToRewards, entries: drawEntries !== null && drawEntries !== void 0 ? drawEntries : 0, draws: draws, drawPrizesWithWinners: drawPrizesWithWinners, latestDrawHistory: latestDrawHistory, drawHistoryRetrieved: drawHistoryRetrieved, drawPrizes: drawPrizes, isEnded: isRewardEnded, isEndingSoon: isRewardEndingSoon, disableButton: loggedIn && maxRedeemAvailable === 0 && !loyaltyBalanceLoading, hideDrawDate: !constants_1.default.SHOW_DRAW_DATE, isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs, showSignInWarning: !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING'), redirectToLogin: redirectToLogin })));
    };
    return (react_1.default.createElement(page_container_1.Container, { pageTitle: (_c = selectedReward === null || selectedReward === void 0 ? void 0 : selectedReward.title) !== null && _c !== void 0 ? _c : t('rewards.rewardDetails') },
        react_1.default.createElement(RedeemConfirmationModal_1.default, { isVisible: showModalConfirmation, onClose: closeModalConfirmationDialog, maxWidth: "sm", email: "winners@kslottery", title: isRedemptionType ? 'Reward Redeemed!' : undefined, text: isRedemptionType
                ? t('rewards.redemptionConfirmationMessage')
                : t('rewards.confirmationMessage') }),
        renderRewardDetail(),
        launchGame ? (react_1.default.createElement(ArcadeGame_1.default, { isLoggedIn: loggedIn, launchGame: launchGame, onCloseGame: closeGame, gameData: arcades === null || arcades === void 0 ? void 0 : arcades.digitalRevealTokenDetails, gamePoints: gamePoints, spinResults: spinResults, isPBLGame: true, onGameExitHandler: gameEnded, gameType: gameType, topPrize: 0, wager: selectedReward.amount, selectedIndex: 0 })) : null,
        react_1.default.createElement(hideable_1.Hideable, { show: loggedIn && showModal && maxRedeemAvailable > 0 },
            react_1.default.createElement(RedeemModal_1.default, { maxRedeemAvailable: maxRedeemAvailable, onRedeem: requestRedeem, onError: showRedeemError, onQuantityChange: setRedeemQuantity, redeemablePoints: loyaltyBalance, open: showModal, quantity: redeemQuantity, selectedReward: __assign(__assign({}, selectedReward), { date_end: (0, moment_1.default)(selectedReward.end).format('X'), num_points: selectedReward.amount }), rewardTerms: selectedReward && selectedReward.termsConditionsUrl, onClose: onModalClose, hideRedeemableQuantity: true, disableSlider: isCouponType || isRedemptionType })),
        react_1.default.createElement(hideable_1.Hideable, { show: loggedIn && showCouponModal && (isCouponType || isRedemptionType) && !!barcodeData },
            react_1.default.createElement(RewardCouponModalV2_1.default, { open: showCouponModal && !!barcodeData, barcodeData: barcodeData, selectedReward: __assign(__assign({}, selectedReward), { date_end: (0, moment_1.default)(selectedReward.end).format('X'), num_points: selectedReward.amount }), onClose: navigateWithRedeemSuccess, maxWidth: 'md' })),
        react_1.default.createElement(hideable_1.Hideable, { show: loggedIn && (isCouponType || isRedemptionType) && showDigitalDownloadModal },
            react_1.default.createElement(package_1.RewardDigitalDownloadModal, { title: selectedReward.title, open: showDigitalDownloadModal, downloadLink: rewardDigitalDownload, onClose: navigateWithRedeemSuccess }))));
};
exports.default = RewardDetailScreen;
//# sourceMappingURL=index.js.map